import { Box, Button, Stack, Text } from '@ltvco/refresh-lib/theme';

import { ButtonBoxContainer } from './components';
import { SummaryComponentProps } from './DataTypes/SummaryTypes';
import {
  PropertyReportRenderer,
  PhoneReportRenderer,
  EmailReportRenderer,
  VehicleReportRenderer,
  PersonReportRenderer,
  PersonTeaserRenderer,
  ObituaryReportRenderer,
  ContactReportRenderer,
  GenealogyReportRenderer,
  UsernameReportRenderer,
} from './ReportRenderers';

const renderReportByType = (reportType: string, reportData: any) => {
  switch (reportType.toLowerCase()) {
    case 'property':
      return <PropertyReportRenderer data={reportData} />;
    case 'phone':
      return <PhoneReportRenderer data={reportData} />;
    case 'email':
      return <EmailReportRenderer data={reportData} />;
    case 'vehicle':
      return <VehicleReportRenderer data={reportData} />;
    case 'person':
      return <PersonReportRenderer data={reportData} />;
    case 'obituary':
      return <ObituaryReportRenderer data={reportData} />;
    case 'contact':
      return <ContactReportRenderer data={reportData} />;
    case 'ancestor':
      return <GenealogyReportRenderer data={reportData} />;
    case 'username':
      return <UsernameReportRenderer data={reportData} />;
    default:
      return null;
  }
};

export const SummaryComponent = ({
  reportData,
  teaser,
  params,
  currentPermalink,
  handleButtonClick,
  reportsAssociated,
}: SummaryComponentProps) => {
  if (teaser?.length) {
    return <PersonTeaserRenderer data={teaser} params={params} />;
  }
  return (
    <Stack spacing={2}>
      {Object.entries(reportData).map(([reportType, reports]) => {
        if (!reports || reports.length === 0) {
          return null;
        }
        return (
          <Stack key={reportType} spacing={2} margin={'24px 0 !important'}>
            {reports.map((report, index) => (
              <Stack key={index}>
                {renderReportByType(reportType, report)}
                <ButtonBoxContainer
                  disabled={
                    !!reportsAssociated &&
                    currentPermalink === reportsAssociated[0]?.permalink
                  }
                >
                  <Text
                    sx={{
                      fontWeight: 700,
                      maxWidth: { xs: '100%', md: 'auto' },
                      textAlign: { xs: 'center', md: 'left' },
                    }}
                  >
                    View the full report{' '}
                    <span style={{ fontWeight: 400 }}>for more details.</span>
                  </Text>
                  {reports && reportsAssociated && (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleButtonClick(reportsAssociated[0])}
                        disabled={
                          currentPermalink === reportsAssociated[0]?.permalink
                        }
                      >
                        View full report
                      </Button>
                    </Box>
                  )}
                </ButtonBoxContainer>
              </Stack>
            ))}
          </Stack>
        );
      })}
    </Stack>
  );
};
